import { render, staticRenderFns } from "./AnnexesCandidature.vue?vue&type=template&id=645750be"
import script from "./AnnexesCandidature.vue?vue&type=script&lang=js"
export * from "./AnnexesCandidature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports